import { useInView } from "../hooks/useInView";
import { PhoneMockup } from "./PhoneMockup";

const screenshots = [
  { src: "/images/screenshots/dashboard.png", label: "Dashboard" },
  { src: "/images/screenshots/finance.png", label: "Finances" },
  { src: "/images/screenshots/learn.png", label: "Learning" },
  { src: "/images/screenshots/simulator.png", label: "Simulator" },
  { src: "/images/screenshots/coach.png", label: "AI Coach" },
  { src: "/images/screenshots/leaderboard.png", label: "Leaderboard" },
];

export function Screenshots() {
  const [ref, inView] = useInView();

  return (
    <section id="screenshots" className="relative py-24 bg-bg-deep">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-white">
            See Dough <span className="text-brand-indigo">in action</span>
          </h2>
          <p className="mt-4 text-text-secondary text-lg">
            A beautiful, intuitive experience designed for your financial journey.
          </p>
        </div>

        {/* Desktop: grid that fits within container */}
        <div
          ref={ref}
          className="hidden lg:grid grid-cols-6 gap-4 items-end"
        >
          {screenshots.map((s, i) => (
            <div
              key={s.label}
              className={`flex flex-col items-center ${
                inView
                  ? `animate-fade-up animate-delay-${(i + 1) * 100}`
                  : "start-hidden"
              }`}
            >
              <PhoneMockup
                src={s.src}
                alt={s.label}
                className="transition-transform duration-300 hover:scale-105"
              />
              <span className="mt-3 text-sm font-medium text-text-tertiary">
                {s.label}
              </span>
            </div>
          ))}
        </div>

        {/* Mobile: horizontal scroll */}
        <div className="lg:hidden flex gap-6 overflow-x-auto snap-x snap-mandatory pb-4 hide-scrollbar px-4">
          {screenshots.map((s) => (
            <div
              key={s.label}
              className="flex-shrink-0 flex flex-col items-center snap-center"
            >
              <PhoneMockup src={s.src} alt={s.label} width={260} />
              <span className="mt-4 text-sm font-medium text-text-tertiary">
                {s.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
